module.exports = __webpack_public_path__ + "img/boboto_bobocoin.gm.092aa5c.png";